import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCashPaymentCoinStash = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "cash-payment-coin-stash" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 14.25,
			x2: .75,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M.75,21.75h16.5a3,3,0,0,0-3-3H10.5a3,3,0,0,0-3-3H.75"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6.75,
			y1: 18.75,
			x2: 10.5,
			y2: 18.75
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "a",
			cx: 17.25,
			cy: 3.75,
			rx: 6,
			ry: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.25,3.75v7.5c0,1.657,2.686,3,6,3s6-1.343,6-3V3.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M23.25,7.5c0,1.657-2.686,3-6,3s-6-1.343-6-3"
		})
	]
});
export default SvgCashPaymentCoinStash;
